import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, Transition as _Transition, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import LoadingState from 'src/pages/LoadingState.vue';
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, {
    key: `Router_APP_${_unref(route).fullPath}`
  }, {
    default: _withCtx(({ Component }) => [
      Component
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            mode: "out-in",
            "enter-active-class": "animated fadeIn",
            "leave-active-class": "animated fadeOut"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_Suspense, {
                key: `suspense_APP_${_unref(route).fullPath}`,
                timeout: "0"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                    key: `component_APP_${_unref(route).fullPath}`
                  }))
                ]),
                fallback: _withCtx(() => [
                  _createVNode(LoadingState)
                ]),
                _: 2
              }, 1024))
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})